import { FC } from 'react';
import { UserAvatarProps } from './types';

export const UserAvatar: FC<UserAvatarProps> = ({ user, showAvatar }) => {
  if (!user || !showAvatar) {
    return null;
  }
  const initials = user.lastName.charAt(0) + user.firstName.charAt(0);
  return (
    <span className="self-start rounded-full bg-primary-60 px-[10px] py-2 text-base text-white">
      {initials.toUpperCase()}
    </span>
  );
};
